import React from "react";
import {
  Segment,
  Grid,
  Header,
  Checkbox,
  Label,
  Icon
} from "semantic-ui-react";

class FilterService extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      activeCategory: false,
      activeSubOptions: []
    };
    this.setActiveCategory = this.setActiveCategory.bind(this);
    this.setSubOptions = this.setSubOptions.bind(this);
    this.selectGroup = this.selectGroup.bind(this);
    this.deselectGroup = this.deselectGroup.bind(this);
    this.isActiveCategory = this.isActiveCategory.bind(this);
    this.countItems = this.countItems.bind(this);
  }

  isActiveCategory(category) {
    return this.state.activeCategory.value === category.value;
  }

  setActiveCategory(activeCategory, selectAll = false, selectNone = false) {
    this.setState({
      activeCategory
    });

    if (activeCategory.hasOwnProperty("subOptions")) {
      this.setSubOptions(activeCategory.subOptions, selectAll, selectNone);
    } else {
      this.setSubOptions([activeCategory], selectAll, selectNone);
    }
  }

  setSubOptions(activeSubOptions, selectAll = false, selectNone = false) {
    let self = this;
    this.setState(
      {
        activeSubOptions
      },
      () => {
        if (selectAll === true) {
          self.selectGroup();
        } else if (selectNone === true) {
          self.deselectGroup();
        }
      }
    );
  }

  flattenSubOptions(activeSubOptions) {
    let flat = [];
    if (activeSubOptions.length) {
      activeSubOptions.map(item => {
        flat.push(item.value);
      });
    }
    return flat;
  }

  getAllServices(possible) {
    let services = [];
    possible.map(category => {
      if (category.hasOwnProperty("subOptions")) {
        category.subOptions.map(item => {
          services.push(item.value);
        });
      } else {
        services.push(category.value);
      }
    });
    return services;
  }

  countItems(category) {
    let self = this;
    let count = 0;
    category.subOptions.map(service => {
      if (self.props.active.includes(service.value)) {
        count++;
      }
    });
    return count;
  }

  categoryCount(category) {
    let self = this;
    if (self.props.active && self.props.active.includes(category.value)) {
      // Single depth service
      return (
        <Label
          circular
          className="selected-filter-count"
          color="pink"
          onClick={() => self.setActiveCategory(category, false, true)}
        >
          1
        </Label>
      );
    } else if (self.props.active && category.hasOwnProperty("subOptions")) {
      let count = this.countItems(category);
      if (count > 0)
        // Double depth service
        return (
          <Label
            circular
            className="selected-filter-count"
            color="pink"
            onClick={() => self.setActiveCategory(category, false, true)}
          >
            {count}
          </Label>
        );
    }

    // Unselected Service
    return (
      <Label
        circular
        className="selected-filter-count"
        onClick={() => self.setActiveCategory(category, true, false)}
      >
        -
      </Label>
    );
  }

  selectGroup() {
    let newSelection;
    if (typeof this.props.active === "undefined") {
      newSelection = [...this.flattenSubOptions(this.state.activeSubOptions)];
    } else {
      newSelection = [
        ...this.props.active,
        ...this.flattenSubOptions(this.state.activeSubOptions)
      ];
    }
    this.props.onSelectMultiple("service", newSelection);
  }

  deselectGroup() {
    let toRemove = this.flattenSubOptions(this.state.activeSubOptions);
    let oldSelection;
    if (typeof this.props.active === "undefined") {
      oldSelection = [];
    } else {
      oldSelection = [...this.props.active];
    }

    let newSelection = [];

    if (oldSelection.length) {
      oldSelection.map(item => {
        if (!toRemove.includes(item)) {
          newSelection.push(item);
        }
      });
    }

    this.props.onSelectMultiple("service", newSelection);
  }

  render() {
    let self = this;
    return (
      <div>
        {this.props.expanded ? (
          <Segment className="filter-section-expanded">
            <Header as="h4" style={{ marginBottom: ".1em" }}>
              Service
            </Header>
            <div className="filter-meta" style={{ marginBottom: ".5em" }}>
              <small
                className="gray-text"
                onClick={() =>
                  self.props.onSelectMultiple(
                    "service",
                    self.getAllServices(self.props.possible)
                  )
                }
              >
                Select All
              </small>
              <span> | </span>
              <small
                className="gray-text"
                onClick={() => self.props.onSelectMultiple("service", [])}
              >
                Select None
              </small>
            </div>
            <Grid stackable columns={2} style={{ marginTop: ".75em" }}>
              <Grid.Column>
                <strong>Categories</strong>
                <div className="filter-controls" style={{ marginTop: ".25em" }}>
                  {this.props.possible.map((category, i) => {
                    return (
                      <div
                        key={"category-" + i}
                        onClick={() => {
                          this.setActiveCategory(category);
                        }}
                        className={
                          self.isActiveCategory(category)
                            ? "filter-category active"
                            : "filter-category"
                        }
                      >
                        {self.categoryCount(category)}
                        {category.text}
                      </div>
                    );
                  })}
                </div>
              </Grid.Column>
              <Grid.Column>
                <strong>Selected Services</strong>
                {typeof this.state.activeSubOptions !== "undefined" &&
                this.state.activeSubOptions.length ? (
                  <div
                    className="filter-meta"
                    style={{ marginBottom: ".5em", marginTop: ".25em" }}
                  >
                    <small className="gray-text" onClick={self.selectGroup}>
                      Select All
                    </small>
                    <span> | </span>
                    <small className="gray-text" onClick={self.deselectGroup}>
                      Select None
                    </small>
                  </div>
                ) : (
                  <div
                    className="filter-meta"
                    style={{ marginBottom: ".5em", marginTop: ".25em" }}
                  >
                    <small className="gray-text">
                      Choose a category first.
                    </small>
                  </div>
                )}
                {this.state.activeSubOptions.map((service, i) => {
                  return (
                    <div key={"check-" + i} style={{ padding: ".1em 0" }}>
                      <Checkbox
                        checked={
                          self.props.active &&
                          self.props.active.includes(service.value)
                        }
                        onChange={() => {
                          self.props.onToggle("service", service.value);
                        }}
                        style={{
                          marginBottom: "0",
                          marginTop: ".75em",
                          marginRight: ".25em",
                          height: "30px",
                          verticalAlign: "middle"
                        }}
                      />
                      <Label
                        onClick={() => {
                          self.props.onToggle("service", service.value);
                        }}
                        style={{
                          height: "30px",
                          verticalAlign: "middle",
                          cursor: "pointer"
                        }}
                      >
                        {service.text}
                      </Label>
                    </div>
                  );
                })}
              </Grid.Column>
            </Grid>
          </Segment>
        ) : (
          <Segment
            className="filter-section-collapsed"
            onClick={() => this.props.setExpanded(true)}
          >
            <Icon
              name="angle double right"
              size="big"
              style={{ float: "right" }}
            />
            <Header as="h4" style={{ margin: ".1em 0" }}>
              Service
            </Header>
            {typeof this.props.active !== "undefined" &&
            this.props.active.length ? (
              <Label color="pink">
                {this.props.active.length} Active Filter
                {this.props.active.length !== 1 ? "s" : null}
              </Label>
            ) : (
              <small>Click to filter...</small>
            )}
          </Segment>
        )}
      </div>
    );
  }
}

export default FilterService;



// WEBPACK FOOTER //
// ./src/components/misc/FilterService.js